module.exports = __webpack_public_path__ + "static/media/field-hockey.6901d361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/field-hockey.jpg
// module id = 688
// module chunks = 0